import React, { useState, useEffect } from "react";
import FadeInSectionDownToUp from "../../Components/FadeAnimations/FadeInSectionDownToUp";
import ContactNumberField from "../../Components/Contact/ContactNumberField";
import { getPhoneMaxLength, validateMobileNumber } from "../../Components/Contact/PhoneValidation";
import { cplCourses, twelfthtakenCourses } from "../../Components/Contact/Qualification";
// import { StateDistricts } from "../../Components/Contact/StateDistricts";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import LocationSelector from "../../Components/Contact/LocationSelector";

export default function CplFormModal({ open, onClose }) {

  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [countryCode, setCountryCode] = useState("");
  const [number, setNumber] = useState("");
  const [mail, setMail] = useState("");
  const [qualification, setQualification] = useState("");
  const [groupTaken12th, setGroupTaken12th] = useState("");
  const [selectNios, setSelectNios] = useState("");
  const [state, setState] = useState("");
  const [district, setDistrict] = useState("");
  const [lookingfor, setLookingfor] = useState("");
  const [hearAbout, setHearAbout] = useState("");
  const [hearOther, setHearOther] = useState("");
  const [message, setMessage] = useState("");
  const [consent, setConsent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // ---------------- VALIDATION HELPERS ----------------
  const onlyLetters = /^[A-Za-z\s]+$/;
  const onlyNumbers = /^[0-9]+$/;
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // ---------------- TOAST STATE ----------------
  const [toast, setToast] = useState({
    show: false,
    message: "",
    type: "",
  });

  const showToast = (message, type = "error") => {
    setToast({
      show: true,
      message,
      type,
    });

    setTimeout(() => {
      setToast({
        show: false,
        message,
        type,
      });
    }, 3000);
  };

  // Disable background scroll when modal is open
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    // Cleanup function to restore overflow when component unmounts
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  const addData = async () => {
    const isIndia = countryCode === "+91";
    const requiredFields = [
      name,
      number,
      countryCode,
      mail,
      qualification,
      lookingfor,
      state,
      ...(isIndia ? [district] : []),
      hearAbout,
    ];
    const hasEmptyFields = requiredFields.some((field) => field === "");

    if (hasEmptyFields) {
      showToast("Please fill in all required fields.");
      return;
    }

    // Check if NIOS is required and selected
    if (groupTaken12th && twelfthtakenCourses[groupTaken12th]?.length > 0 && !selectNios) {
      showToast("Please select NIOS option.");
      return;
    }

    if (hearAbout === "Other" && hearOther.trim() === "") {
      showToast("Please specify how you heard about MH Cockpit.");
      return;
    }

    if (!onlyLetters.test(name)) {
      showToast("Name should contain only letters.");
      return;
    }

    if (name.length > 50) {
      showToast("Name should not exceed 50 characters.");
      return;
    }

    if (!emailRegex.test(mail)) {
      showToast("Please enter a valid email.");
      return;
    }

    if (!onlyNumbers.test(number)) {
      showToast("Mobile number should contain only numbers.");
      return;
    }

    const phoneValidation = validateMobileNumber(countryCode, number);
    if (!phoneValidation.valid) {
      showToast(phoneValidation.message);
      return;
    }

    if (!consent) {
      showToast("Please authorize MH Cockpit to contact you.");
      return;
    }

    try {
      setIsLoading(true);
      // Get date & time
      const now = new Date();
      const createdDate = now.toISOString().split('T')[0]; // YYYY-MM-DD
      const createdTime = now.toTimeString().split(' ')[0]; // HH:MM:SS

 

      const newData = {
        Name: name,
        Country_code: countryCode,
        Mobile_Number: number,
        Email: mail,
        Qualification: qualification,
        Looking_For: lookingfor,
        NIOS_status: selectNios,
        State: state,
        Zip_code: district,
        Heard_About: hearAbout === "Other" ? hearOther : hearAbout,
        group_taken_in_12th: groupTaken12th,
        Message_Box: message,
        Consent: consent ? "Yes" : "No",
        Created_Date: createdDate,
        Created_Time: createdTime,
        Source_Page: "https://cpl.mhcockpit.com", // <-- NEW COLUMN
      };
      await axios.post("https://sheetdb.io/api/v1/d6aigwrmryn5s", newData);

      // Reset form
      setName("");
      setCountryCode("");
      setNumber("");
      setMail("");
      setQualification("");
      setGroupTaken12th("");
      setSelectNios("");
      setState("");
      setDistrict("");
      setHearAbout("");
      setHearOther("");
      setMessage("");
      setConsent(false);

      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", {
          send_to: "AW-18381138155/qXeFCJqtkN8cEOvR57xE",
        });
      }

      // alert("Your form has been submitted successfully!");
      // onClose();
      navigate('/thank-you');
    } catch (error) {
      console.error("Error in Submission", error);
    }finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`fixed inset-0 flex items-center justify-center z-50 transition-opacity duration-300 ease-out ${
        open ? "opacity-100 pointer-events-auto" : "opacity-0 pointer-events-none"
      }`}
    >
      {/* Backdrop */}
      <div
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      ></div>
      {/* Modal */}
      <div
        className={`bg-white rounded-xl shadow-xl w-full max-w-2xl my-6 overflow-hidden transform transition-all duration-300 ease-out relative ${
          open ? "scale-100" : "scale-95"
        }`}
        style={{
          WebkitOverflowScrolling: 'touch'
        }}
      >
        <div className="max-h-[calc(100vh-96px)] overflow-y-auto bg-white rounded-xl">
        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-900">Enquiry Form</h2>
          <button
            onClick={onClose}
            className="text-black hover:text-gray-600 text-xl"
          >
            ✕
          </button>
        </div>

        <div className="p-6">
          <FadeInSectionDownToUp>

          <div className="space-y-3">
            {/* First row: Name & Email */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="">
                <label className="block text-sm font-medium mb-1">Name<span className="text-red-500">*</span></label>
                <input
                  type="text"
                  placeholder="Name"
                  className="w-full px-3 py-2 rounded-md border text-black"
                  value={name}
                  maxLength={50}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[A-Za-z\s]*$/.test(value)) {
                      setName(value);
                    }
                  }}
                />
              </div>
              <div className="">
                <label className="block text-sm font-medium mb-1">Email ID<span className="text-red-500">*</span></label>
                <input
                  type="text"
                  placeholder="Email ID"
                  className="w-full px-3 py-2 rounded-md border"
                  value={mail}
                  onChange={(e) => setMail(e.target.value)}
                />
              </div>
            </div>

            {/* Second row: Mobile Number */}
            <div className="">
              <ContactNumberField
                countryCode={countryCode}
                number={number}
                onCountryChange={(countryInfo) => {
                  setCountryCode(countryInfo.code);
                  setNumber("");
                  setState("");
                  setDistrict("");
                }}
                onNumberChange={setNumber}
                maxLength={getPhoneMaxLength(countryCode)}
                required
                placeholder="Mobile Number"
                labelClassName="block text-sm font-medium mb-1"
              />
            </div>

            {/* Third row: Qualification & Looking For */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="">
                <label className="block text-sm font-medium mb-1">Qualification<span className="text-red-500">*</span></label>
                <select
                  className="w-full px-3 py-2 rounded-md border text-black"
                  value={qualification}
                  onChange={(e) => {
                    setQualification(e.target.value);
                  }}
                >
                  <option value="" disabled hidden>
                    Select Qualification
                  </option>
                  {Object.keys(cplCourses).map((qual) => (
                    <option key={qual} value={qual}>
                      {qual}
                    </option>
                  ))}
                </select>
              </div>
              <div className="">
                <label className="block text-sm font-medium mb-1">Looking For<span className="text-red-500">*</span></label>
                <select
                  className="w-full rounded-md py-2 px-3 border text-black"
                  disabled={!qualification}
                  value={lookingfor}
                  onChange={(e) => setLookingfor(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Select Option
                  </option>
                  {qualification && cplCourses[qualification]?.map((course) => (
                    <option key={course} value={course}>
                      {course}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Fourth row: Group Taken in 12th & Select NIOS */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="">
                <label className="block text-sm font-medium mb-1">Group Taken in 12th</label>
                <select
                  className="w-full px-3 py-2 rounded-md border text-black"
                  value={groupTaken12th}
                  onChange={(e) => {
                    setGroupTaken12th(e.target.value);
                    setSelectNios("");
                  }}
                >
                  <option value="" disabled hidden>
                    Select Group
                  </option>
                  {Object.keys(twelfthtakenCourses).map((group) => (
                    <option key={group} value={group}>
                      {group}
                    </option>
                  ))}
                </select>
              </div>
              <div className="">
                <label className="block text-sm font-medium mb-1">
                  Select NIOS
                  {groupTaken12th && twelfthtakenCourses[groupTaken12th]?.length > 0 && (
                    <span className="text-red-500">*</span>
                  )}
                </label>
                <select
                  className="w-full rounded-md py-2 px-3 border text-black cursor-not-allowed"
                  disabled={!groupTaken12th || twelfthtakenCourses[groupTaken12th]?.length === 0}
                  value={selectNios}
                  onChange={(e) => setSelectNios(e.target.value)}
                >
                  <option value="" disabled hidden>
                    Select Option
                  </option>
                  {groupTaken12th && twelfthtakenCourses[groupTaken12th]?.map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Fifth row: State & City/District */}
            {/* <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
              <div className="">
                <label className="block text-sm font-medium mb-1">State<span className="text-red-500">*</span></label>
                <select
                  className="w-full rounded-md py-2 px-3 border text-black"
                  value={state}
                  onChange={(e) => {
                    setState(e.target.value);
                    setDistrict("");
                  }}
                >
                  <option value="" disabled hidden>
                    Select State
                  </option>
                  {Object.keys(StateDistricts).map((stateName) => (
                    <option key={stateName} value={stateName}>
                      {stateName}
                    </option>
                  ))}
                </select>
              </div>
              <div className="">
                <label className="block text-sm font-medium mb-1">City/District<span className="text-red-500">*</span></label>
                <select
                  className="w-full rounded-md py-2 px-3 border text-black"
                  value={district}
                  onChange={(e) => setDistrict(e.target.value)}
                  disabled={!state}
                >
                  <option value="" disabled hidden>
                    Select District
                  </option>
                  {state &&
                    StateDistricts[state]?.map((districtName) => (
                      <option key={districtName} value={districtName}>
                        {districtName}
                      </option>
                    ))}
                </select>
              </div>
            </div> */}
            <LocationSelector
                countryCode={countryCode}
                state={state}
                setState={setState}
                district={district}
                setDistrict={setDistrict}
            />
            {/* Sixth row: How did you hear about MH Cockpit? */}
            <div className="">
              <label className="block text-sm font-medium mb-1">How did you hear about MH Cockpit?<span className="text-red-500">*</span></label>
              <select
                className="w-full px-3 py-2 rounded-md border text-black"
                value={hearAbout}
                onChange={(e) => setHearAbout(e.target.value)}
              >
                <option value="" disabled hidden>Select</option>
                <option>Google / Bing / Search Engine</option>
                <option>Social Media (FB, Insta, etc.)</option>
                <option>Referred by Friends / Relatives</option>
                <option>Alumni (Passed Out)</option>
                <option>AI Recommended (ChatGPT, Gemini, etc.)</option>
                <option>Advertisement (online / offline)</option>
                <option>Event / Workshop / Expo</option>
                <option value="Other">Other (please specify)</option>
              </select>

              {hearAbout === "Other" && (
                <input
                  className="w-full px-3 py-2 rounded-md border mt-2"
                  placeholder="Please specify"
                  value={hearOther}
                  onChange={(e) => setHearOther(e.target.value)}
                />
              )}
            </div>

            {/* Seventh row: Message */}
            <div className="">
              <label className="block text-sm font-medium mb-1">Message (Optional)</label>
              <input
                type="text"
                placeholder="Message Box (optional)"
                className="w-full px-3 py-2 rounded-md border"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
            </div>

            {/* Consent */}
            <div className=" flex items-start">
              <input
                type="checkbox"
                id="consent"
                className="mt-1 mr-2"
                checked={consent}
                onChange={(e) => setConsent(e.target.checked)}
              />
              <label htmlFor="consent" className="text-sm text-gray-700 checked={consent} onChange={(e) => setConsent(e.target.checked)}">
                I authorize <strong>MH Cockpit</strong> to contact me via Email, SMS, WhatsApp, and Call.
              </label>
            </div>

            {/* Submit Button */}
            <center className="">
              <button
                onClick={addData}
                disabled={!consent || isLoading}
                className={`px-10 py-2 rounded-md shadow transition-all duration-300
                ${consent
                        ? "bg-blue-600 hover:bg-gray-300 cursor-pointer text-white"
                        : "bg-gray-400 cursor-not-allowed text-white"
                }`}
              >
              {isLoading ? (
                  <>
                      <svg className="animate-spin h-5 w-5 text-gray-700 inline mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                          <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                      Submitting...
                  </>
              ) : (
                  "Submit"
              )}
              </button>
            </center>
          </div>

        </FadeInSectionDownToUp>
        </div>
        </div>
      </div>
      {
        toast.show && (
          <div className="fixed top-5 right-5 z-50">
            <div
              className={`px-6 py-3 rounded-lg shadow-2xl text-white font-semibold transition-all duration-300
              ${toast.type === "success"
                ? "bg-green-600"
                : "bg-red-500"
              }`}
            >
              {toast.message}
            </div>
          </div>
        )
      }
    </div>
  );
}
